var map = {
	"./bg.json": 9,
	"./cs.json": 10,
	"./da.json": 11,
	"./de.json": 12,
	"./el.json": 13,
	"./en.json": 14,
	"./es.json": 15,
	"./et.json": 16,
	"./fi.json": 17,
	"./fr.json": 18,
	"./hr.json": 19,
	"./hu.json": 20,
	"./it.json": 21,
	"./lb.json": 22,
	"./lt.json": 23,
	"./nl.json": 24,
	"./pl.json": 25,
	"./pt.json": 26,
	"./ro.json": 27,
	"./sk.json": 6,
	"./sl.json": 28,
	"./sv.json": 29
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;